import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';
import { CustomThemeProvider } from './context/ThemeContext';

// Suppress noisy uncaught promise rejections for expected HTTP 429 rate-limits
window.addEventListener('unhandledrejection', (event) => {
  try {
    const reason = event.reason;
    const status = reason && reason.response && reason.response.status;
    if (status === 429) {
      console.warn('Suppressed unhandled 429 (Too Many Requests)', reason);
      event.preventDefault();
    }
  } catch (e) {
    // ignore handler errors
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CustomThemeProvider>
      <App />
    </CustomThemeProvider>
  </React.StrictMode>
);
